import { interpolateSpectral } from 'd3-scale-chromatic'

export const calculatePoint = (i, intervalSize, colorRangeInfo) => {
  const { colorStart, colorEnd, useEndAsStart } = colorRangeInfo
  return useEndAsStart ? colorEnd - i * intervalSize : colorStart + i * intervalSize
}

/* Must use an interpolated color scale, which has a range of [0, 1] */

const defaultColorRangeInfo = {
  colorStart: 0.1,
  colorEnd: 1,
  useEndAsStart: false,
}

export const interpolateColors = (
  dataLength,
  colorScale = interpolateSpectral,
  colorRangeInfo = defaultColorRangeInfo
) => {
  const { colorStart, colorEnd } = colorRangeInfo
  const colorRange = colorEnd - colorStart
  const intervalSize = colorRange / dataLength
  let i
  let colorPoint
  const colorArray = []

  for (i = 0; i < dataLength; i++) {
    colorPoint = calculatePoint(i, intervalSize, colorRangeInfo)
    colorArray.push(colorScale(colorPoint))
  }

  return colorArray
}
